import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { transferApi } from './transferSlice';
import { throwErrorToast, getOAuth2StartUrl } from 'utils';
import { errorMessages } from 'constants/messages';

export const transferApiQueryErrorLogger: Middleware = () => next => action => {
    if (action.type.split('/')[0] === transferApi.reducerPath && isRejectedWithValue(action)) {
        switch (action.payload.originalStatus || action.payload.status) {
            case 401:
                throwErrorToast({
                    message: errorMessages[401],
                    action,
                    errorCode: 401,
                });
                location.replace(getOAuth2StartUrl());
                break;

            case 403:
                console.warn(`Type: ${action.type}`);
                console.warn(`We got a rejected action in API! (ERROR CODE 403) - ${action.meta.arg.endpointName}`);
                console.warn(action.payload);
                break;

            case 422:
                throwErrorToast({
                    message: action.payload.data.errorString ?? errorMessages[422],
                    action,
                    errorCode: 422,
                });
                break;

            case 503:
                throwErrorToast({
                    message: action.payload.data.errorString ?? errorMessages[503],
                    action,
                    errorCode: 503,
                });
                break;

            default:
                throwErrorToast({
                    message: errorMessages[500],
                    action,
                    errorCode: 500,
                });
                break;
        }
    }

    return next(action);
};
